module.exports = __webpack_public_path__ + "img/Mike Favresm.adf4831d.jpg";